<div class="progress">
  <span
    [ngStyle]="{width: percent+'%'}"
    class="progress__line">
  </span>
</div>
